import { type ReactNode } from 'react'
import { cn } from '#app/utils/misc.tsx'

export function SplitAuthLayout({
	children,
	sidePanel,
	className,
}: {
	children: ReactNode
	sidePanel: ReactNode
	className?: string
}) {
	return (
		<div
			className={cn(
				'grid min-h-[calc(100svh-4rem)] lg:grid-cols-2',
				className,
			)}
		>
			<div className="flex flex-col gap-6 px-6 py-10 md:px-10">
				<div className="flex flex-1 items-center justify-center">
					<div className="w-full max-w-sm">{children}</div>
				</div>
			</div>
			<aside className="relative hidden overflow-hidden bg-[#121215] lg:block">
				{sidePanel}
			</aside>
		</div>
	)
}
